import { createFileRoute } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { CalendarRange } from "lucide-react";

export const Route = createFileRoute("/admin/offers")({
  component: () => (
    <StubAdminPage
      icon={CalendarRange}
      title="Offers"
      subtitle="Manage transfer offers and inventory"
    />
  ),
});
